var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRewind = function SvgRewind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#414142",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.003 11.546 11.466 6.42V5l-11.466 6.546Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 11.574 6.442 4.129 4.076 2.74-.52-6.96.121-6.273-4.153 3.117L1 11.574Z"
  })));
};
export default SvgRewind;